function init() {
  window.setTimeout(initializeCustomizationAdditionalCosts, 100);
}

// The custom fields additional-costs display doesn't take into account the initial quantity value - always defaults to 1.
// Force it to refresh by forcing a change event.
function initializeCustomizationAdditionalCosts() {
  document.querySelectorAll('.qty').forEach(qtyInput => {
    qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
  });
}

export default { init };
